import React from 'react';
import classnames from 'classnames';
import search from "./search.svg";
import styles from './styles.module.scss';

const FilterInput = ({
                      type = 'text',
                      placeholder,
                      value,
                      onChange,
                      customClassName
                    }) => {

  return (
    <div className={classnames(styles.container, customClassName)}>
      <img src={search} alt="search" className={styles.icon}/>
      <input
        type={type}
        placeholder={placeholder}
        className={styles.input}
        value={value}
        onChange={onChange}
        onKeyDown={(e) => {
          e.stopPropagation();
        }}
      />
    </div>
  )
};

export default FilterInput;